// extracted by mini-css-extract-plugin
export var menu = "header-module--menu--MFCcM";
export var brandContainer = "header-module--brandContainer--mD04d";